// Copyright (c) Docugami, Inc. All rights reserved.

import { DgSingleLineEllipsis } from "components/common/DgCommonStyledComponents";
import { dgTagFontFamily, SmallHeaderLabel } from "components/common/Fonts";
import { greyText, primaryTheme } from "components/shell/presentation/AppStyles";
import styled from "styled-components";

const RootContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`

const ListContainer = styled.div`
    display: flex;
    gap: 2px;
    flex-direction: row;
    flex-wrap: wrap;
`

const LabelText = styled(SmallHeaderLabel)`
    color: ${greyText};
    user-select: none;
`;

const TagText = styled(DgSingleLineEllipsis)`
    font-family: ${dgTagFontFamily};
    font-weight: 700;
    font-size: 12px;
    max-width: 100px;
    color: ${greyText};
    :not(:last-child) {
        margin-right: 8px;
    }
    :hover {
        cursor: pointer;
        color: ${primaryTheme.palette.black};
    }
`;

export interface TagListProps {
    label?: string;
    tags: string[];
    onSelected?: (tag: string) => void;
}

export const TagList = (props: TagListProps): JSX.Element => {
    return (
        <RootContainer>
            {!!props.label && <LabelText>{props.label}</LabelText> }
            <ListContainer>
                {props.tags.map(name => {
                    return (
                        <TagText key={name} onClick={() => props.onSelected?.(name)}>
                            {name}
                        </TagText>
                    )
                })}
            </ListContainer>
        </RootContainer>
    )
}
